const customStylesSelect = {

  control: () => ({
    borderRadius: '5px',
    background: '#fff',
    display: 'flex',
  }),

  dropdownIndicator: () => ({
    color: '#4593ea',
    transform: 'scale(.8)',
    paddingRight: '10px'
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  valueContainer: (base, state) => ({
    ...base,
    padding: '10px 15px',
  }),

};

export default customStylesSelect;
